function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n3 = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n3 >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n3++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { Plugin as E } from "../../../../../@ckeditor_ckeditor5-core@45.2.1/node_modules/@ckeditor/ckeditor5-core/dist/index.js";
import { MouseObserver as H, TreeWalker as K } from "../../../../../@ckeditor_ckeditor5-engine@45.2.1/node_modules/@ckeditor/ckeditor5-engine/dist/index.js";
import { Delete as V } from "../../../../../@ckeditor_ckeditor5-typing@45.2.1/node_modules/@ckeditor/ckeditor5-typing/dist/index.js";
import { keyCodes as P, env as D, getLocalizedArrowKeyCodeDirection as j, logWarning as $, CKEditorError as I, isForwardArrowKeyCode as U, getRangeFromMouseEvent as q, global as T, DomEmitterMixin as G, toArray as O, Rect as b, ObservableMixin as F, compareArrays as Y, EmitterMixin as X } from "../../../../../@ckeditor_ckeditor5-utils@45.2.1/node_modules/@ckeditor/ckeditor5-utils/dist/index.js";
import { IconReturnArrow as J, IconDragHandle as Q } from "../../../../../@ckeditor_ckeditor5-icons@45.2.1/node_modules/@ckeditor/ckeditor5-icons/dist/index.js";
import { ContextualBalloon as Z, ToolbarView as ee, BalloonPanelView as te, IconView as ie, Template as C, View as oe } from "../../../../../@ckeditor_ckeditor5-ui@45.2.1/node_modules/@ckeditor/ckeditor5-ui/dist/index.js";
import { Enter as ne } from "../../../../../@ckeditor_ckeditor5-enter@45.2.1/node_modules/@ckeditor/ckeditor5-enter/dist/index.js";
import { throttle as se } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/function/throttle.js"; /**
                                                                                                                            * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                            * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                            */
var re = /*#__PURE__*/function (_X) {
  function re() {
    var _this;
    _classCallCheck(this, re);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, re, [].concat(args));
    _defineProperty(_this, "_stack", []);
    return _this;
  }
  _inherits(re, _X);
  return _createClass(re, [{
    key: "add",
    value: function add(e, t) {
      var i = this._stack,
        o = i[0];
      this._insertDescriptor(e);
      var n = i[0];
      o !== n && !S(o, n) && this.fire("change:top", {
        oldDescriptor: o,
        newDescriptor: n,
        writer: t
      });
    }
  }, {
    key: "remove",
    value: function remove(e, t) {
      var i = this._stack,
        o = i[0];
      this._removeDescriptor(e);
      var n = i[0];
      o !== n && !S(o, n) && this.fire("change:top", {
        oldDescriptor: o,
        newDescriptor: n,
        writer: t
      });
    }
  }, {
    key: "_insertDescriptor",
    value: function _insertDescriptor(e) {
      var t = this._stack,
        i = t.findIndex(function (n) {
          return n.id === e.id;
        });
      if (S(e, t[i])) return;
      i > -1 && t.splice(i, 1);
      var o = 0;
      for (; t[o] && le(t[o], e);) o++;
      t.splice(o, 0, e);
    }
  }, {
    key: "_removeDescriptor",
    value: function _removeDescriptor(e) {
      var t = this._stack,
        i = t.findIndex(function (o) {
          return o.id === e;
        });
      i > -1 && t.splice(i, 1);
    }
  }]);
}(X());
function S(s, e) {
  return s && e && s.priority == e.priority && v(s.classes) == v(e.classes);
}
function le(s, e) {
  return s.priority > e.priority ? !0 : s.priority < e.priority ? !1 : v(s.classes) > v(e.classes);
}
function v(s) {
  return Array.isArray(s) ? s.sort().join(",") : s;
}
var ce = "ck-widget",
  k = "ck-widget_selected";
function p(s) {
  return s.is("element") ? !!s.getCustomProperty("widget") : !1;
}
function Ze(s, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!s.is("containerElement")) throw new I("widget-to-widget-wrong-element-type", null, {
    element: s
  });
  return e.setAttribute("contenteditable", "false", s), e.addClass(ce, s), e.setCustomProperty("widget", !0, s), s.getFillerOffset = ge, e.setCustomProperty("widgetLabel", [], s), t.label && he(s, t.label), t.hasSelectionHandle && pe(s, e), N(s, e), s;
}
function ae(s, e, t) {
  if (e.classes && t.addClass(O(e.classes), s), e.attributes) for (var i in e.attributes) t.setAttribute(i, e.attributes[i], s);
}
function de(s, e, t) {
  if (e.classes && t.removeClass(O(e.classes), s), e.attributes) for (var i in e.attributes) t.removeAttribute(i, s);
}
function N(s, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ae;
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : de;
  var o = new re();
  o.on("change:top", function (l, c) {
    c.oldDescriptor && i(s, c.oldDescriptor, c.writer), c.newDescriptor && t(s, c.newDescriptor, c.writer);
  });
  var n = function n(l, c, a) {
      return o.add(c, a);
    },
    r = function r(l, c, a) {
      return o.remove(c, a);
    };
  e.setCustomProperty("addHighlight", n, s), e.setCustomProperty("removeHighlight", r, s);
}
function he(s, e) {
  s.getCustomProperty("widgetLabel").push(e);
}
function ue(s) {
  return s.getCustomProperty("widgetLabel").reduce(function (t, i) {
    return typeof i == "function" ? t ? t + ". " + i() : i() : t ? t + ". " + i : i;
  }, "");
}
function et(s, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return e.addClass(["ck-editor__editable", "ck-editor__nested-editable"], s), t.withAriaRole !== !1 && e.setAttribute("role", "textbox", s), e.setAttribute("tabindex", "-1", s), t.label && e.setAttribute("aria-label", t.label, s), e.setAttribute("contenteditable", s.isReadOnly ? "false" : "true", s), s.on("change:isReadOnly", function (i, o, n) {
    e.setAttribute("contenteditable", n ? "false" : "true", s);
  }), s.on("change:isFocused", function (i, o, n) {
    n ? e.addClass("ck-editor__nested-editable_focused", s) : e.removeClass("ck-editor__nested-editable_focused", s);
  }), N(s, e), s;
}
function tt(s, e) {
  var t = s.getSelectedElement();
  if (t) {
    var i = w(s);
    if (i) return e.createRange(e.createPositionAt(t, i));
  }
  return e.schema.findOptimalInsertionRange(s);
}
function ge() {
  return null;
}
function pe(s, e) {
  var t = e.createUIElement("div", {
    class: "ck ck-widget__selection-handle"
  }, function (i) {
    var o = this.toDomElement(i),
      n = new ie();
    return n.set("content", Q), n.render(), o.appendChild(n.element), o;
  });
  e.insert(e.createPositionAt(s, 0), t), e.addClass(["ck-widget_with-selection-handle"], s);
}
function fe(s) {
  var e = function e(l) {
      var _l$ownerDocument$defa = l.ownerDocument.defaultView.getComputedStyle(l),
        c = _l$ownerDocument$defa.width,
        a = _l$ownerDocument$defa.paddingLeft,
        h = _l$ownerDocument$defa.paddingRight;
      return parseFloat(c) - (parseFloat(a) || 0) - (parseFloat(h) || 0);
    },
    t = s.parentElement;
  if (!t) return 0;
  var i = e(t);
  var o = 5;
  var n = 0,
    r = t;
  for (; isNaN(i);) {
    if (r = r.parentElement, ++n > o) return 0;
    i = e(r);
  }
  return i;
}
function me(s) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new b(s);
  var t = fe(s);
  return t ? e.width / t * 100 : 0;
}
var m = "widget-type-around";
function _(s, e, t) {
  return !!s && p(s) && !t.isInline(e);
}
function we(s) {
  return s.closest(".ck-widget__type-around__button");
}
function _e(s) {
  return s.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
}
function be(s, e) {
  var t = s.closest(".ck-widget");
  return e.mapDomToView(t);
}
function w(s) {
  return s.getAttribute(m);
}
var M = ["before", "after"],
  ye = new DOMParser().parseFromString(J, "image/svg+xml").firstChild,
  A = "ck-widget__type-around_disabled";
var ve = /*#__PURE__*/function (_E) {
  function ve() {
    var _this2;
    _classCallCheck(this, ve);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _callSuper(this, ve, [].concat(args));
    _defineProperty(_this2, "_currentFakeCaretModelElement", null);
    return _this2;
  }
  _inherits(ve, _E);
  return _createClass(ve, [{
    key: "init",
    value: function init() {
      var e = this.editor,
        t = e.editing.view;
      this.on("change:isEnabled", function (i, o, n) {
        t.change(function (r) {
          var _iterator = _createForOfIteratorHelper(t.document.roots),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var l = _step.value;
              n ? r.removeClass(A, l) : r.addClass(A, l);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }), n || e.model.change(function (r) {
          r.removeSelectionAttribute(m);
        });
      }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableInsertObjectIntegration(), this._enableDeleteContentIntegration();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(ve, "destroy", this, 3)([]), this._currentFakeCaretModelElement = null;
    }
  }, {
    key: "_insertParagraph",
    value: function _insertParagraph(e, t) {
      var i = this.editor,
        o = i.editing.view,
        n = i.model.schema.getAttributesWithProperty(e, "copyOnReplace", !0);
      i.execute("insertParagraph", {
        position: i.model.createPositionAt(e, t),
        attributes: n
      }), o.focus(), o.scrollToTheSelection();
    }
  }, {
    key: "_listenToIfEnabled",
    value: function _listenToIfEnabled(e, t, i, o) {
      var _this3 = this;
      this.listenTo(e, t, function () {
        _this3.isEnabled && i.apply(void 0, arguments);
      }, o);
    }
  }, {
    key: "_insertParagraphAccordingToFakeCaretPosition",
    value: function _insertParagraphAccordingToFakeCaretPosition() {
      var i = this.editor.model.document.selection,
        o = w(i);
      if (!o) return !1;
      var n = i.getSelectedElement();
      return this._insertParagraph(n, o), !0;
    }
  }, {
    key: "_enableTypeAroundUIInjection",
    value: function _enableTypeAroundUIInjection() {
      var _this4 = this;
      var e = this.editor,
        t = e.model.schema,
        i = e.locale.t,
        o = {
          before: i("Insert paragraph before block"),
          after: i("Insert paragraph after block")
        };
      e.editing.downcastDispatcher.on("insert", function (n, r, l) {
        var c = l.mapper.toViewElement(r.item);
        c && _(c, r.item, t) && (Ee(l.writer, o, c), c.getCustomProperty("widgetLabel").push(function () {
          return _this4.isEnabled ? i("Press Enter to type after or press Shift + Enter to type before the widget") : "";
        }));
      }, {
        priority: "low"
      });
    }
  }, {
    key: "_enableTypeAroundFakeCaretActivationUsingKeyboardArrows",
    value: function _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
      var _this5 = this;
      var e = this.editor,
        t = e.model,
        i = t.document.selection,
        o = t.schema,
        n = e.editing.view;
      this._listenToIfEnabled(n.document, "arrowKey", function (l, c) {
        _this5._handleArrowKeyPress(l, c);
      }, {
        context: [p, "$text"],
        priority: "high"
      }), this._listenToIfEnabled(i, "change:range", function (l, c) {
        c.directChange && e.model.change(function (a) {
          a.removeSelectionAttribute(m);
        });
      }), this._listenToIfEnabled(t.document, "change:data", function () {
        var l = i.getSelectedElement();
        if (l) {
          var c = e.editing.mapper.toViewElement(l);
          if (_(c, l, o)) return;
        }
        e.model.change(function (c) {
          c.removeSelectionAttribute(m);
        });
      }), this._listenToIfEnabled(e.editing.downcastDispatcher, "selection", function (l, c, a) {
        var h = a.writer;
        if (_this5._currentFakeCaretModelElement) {
          var f = a.mapper.toViewElement(_this5._currentFakeCaretModelElement);
          f && (h.removeClass(M.map(r), f), _this5._currentFakeCaretModelElement = null);
        }
        var d = c.selection.getSelectedElement();
        if (!d) return;
        var g = a.mapper.toViewElement(d);
        if (!_(g, d, o)) return;
        var u = w(c.selection);
        u && (h.addClass(r(u), g), _this5._currentFakeCaretModelElement = d);
      }), this._listenToIfEnabled(e.ui.focusTracker, "change:isFocused", function (l, c, a) {
        a || e.model.change(function (h) {
          h.removeSelectionAttribute(m);
        });
      });
      function r(l) {
        return "ck-widget_type-around_show-fake-caret_".concat(l);
      }
    }
  }, {
    key: "_handleArrowKeyPress",
    value: function _handleArrowKeyPress(e, t) {
      var i = this.editor,
        o = i.model,
        n = o.document.selection,
        r = o.schema,
        l = i.editing.view,
        c = t.keyCode,
        a = U(c, i.locale.contentLanguageDirection),
        h = l.document.selection.getSelectedElement(),
        d = i.editing.mapper.toModelElement(h);
      var g;
      _(h, d, r) ? g = this._handleArrowKeyPressOnSelectedWidget(a) : n.isCollapsed ? g = this._handleArrowKeyPressWhenSelectionNextToAWidget(a) : t.shiftKey || (g = this._handleArrowKeyPressWhenNonCollapsedSelection(a)), g && (t.preventDefault(), e.stop());
    }
  }, {
    key: "_handleArrowKeyPressOnSelectedWidget",
    value: function _handleArrowKeyPressOnSelectedWidget(e) {
      var i = this.editor.model,
        o = i.document.selection,
        n = w(o);
      return i.change(function (r) {
        if (n) {
          if (!(n === (e ? "after" : "before"))) return r.removeSelectionAttribute(m), !0;
        } else return r.setSelectionAttribute(m, e ? "after" : "before"), !0;
        return !1;
      });
    }
  }, {
    key: "_handleArrowKeyPressWhenSelectionNextToAWidget",
    value: function _handleArrowKeyPressWhenSelectionNextToAWidget(e) {
      var t = this.editor,
        i = t.model,
        o = i.schema,
        n = t.plugins.get("Widget"),
        r = n._getObjectElementNextToSelection(e),
        l = t.editing.mapper.toViewElement(r);
      return _(l, r, o) ? (i.change(function (c) {
        n._setSelectionOverElement(r), c.setSelectionAttribute(m, e ? "before" : "after");
      }), !0) : !1;
    }
  }, {
    key: "_handleArrowKeyPressWhenNonCollapsedSelection",
    value: function _handleArrowKeyPressWhenNonCollapsedSelection(e) {
      var t = this.editor,
        i = t.model,
        o = i.schema,
        n = t.editing.mapper,
        r = i.document.selection,
        l = e ? r.getLastPosition().nodeBefore : r.getFirstPosition().nodeAfter,
        c = n.toViewElement(l);
      return _(c, l, o) ? (i.change(function (a) {
        a.setSelection(l, "on"), a.setSelectionAttribute(m, e ? "after" : "before");
      }), !0) : !1;
    }
  }, {
    key: "_enableInsertingParagraphsOnButtonClick",
    value: function _enableInsertingParagraphsOnButtonClick() {
      var _this6 = this;
      var e = this.editor,
        t = e.editing.view;
      this._listenToIfEnabled(t.document, "mousedown", function (i, o) {
        var n = we(o.domTarget);
        if (!n) return;
        var r = _e(n),
          l = be(n, t.domConverter),
          c = e.editing.mapper.toModelElement(l);
        _this6._insertParagraph(c, r), o.preventDefault(), i.stop();
      });
    }
  }, {
    key: "_enableInsertingParagraphsOnEnterKeypress",
    value: function _enableInsertingParagraphsOnEnterKeypress() {
      var _this7 = this;
      var e = this.editor,
        t = e.model.document.selection,
        i = e.editing.view;
      this._listenToIfEnabled(i.document, "enter", function (o, n) {
        if (o.eventPhase != "atTarget") return;
        var r = t.getSelectedElement(),
          l = e.editing.mapper.toViewElement(r),
          c = e.model.schema;
        var a;
        _this7._insertParagraphAccordingToFakeCaretPosition() ? a = !0 : _(l, r, c) && (_this7._insertParagraph(r, n.isSoft ? "before" : "after"), a = !0), a && (n.preventDefault(), o.stop());
      }, {
        context: p
      });
    }
  }, {
    key: "_enableInsertingParagraphsOnTypingKeystroke",
    value: function _enableInsertingParagraphsOnTypingKeystroke() {
      var _this8 = this;
      var t = this.editor.editing.view.document;
      this._listenToIfEnabled(t, "insertText", function (i, o) {
        _this8._insertParagraphAccordingToFakeCaretPosition() && (o.selection = t.selection);
      }, {
        priority: "high"
      }), D.isAndroid ? this._listenToIfEnabled(t, "keydown", function (i, o) {
        o.keyCode == 229 && _this8._insertParagraphAccordingToFakeCaretPosition();
      }) : this._listenToIfEnabled(t, "compositionstart", function () {
        _this8._insertParagraphAccordingToFakeCaretPosition();
      }, {
        priority: "highest"
      });
    }
  }, {
    key: "_enableDeleteIntegration",
    value: function _enableDeleteIntegration() {
      var e = this.editor,
        t = e.editing.view,
        i = e.model,
        o = i.schema;
      this._listenToIfEnabled(t.document, "delete", function (n, r) {
        if (n.eventPhase != "atTarget") return;
        var l = w(i.document.selection);
        if (!l) return;
        var c = r.direction,
          a = i.document.selection.getSelectedElement(),
          h = l === "before",
          d = c == "forward";
        if (h === d) e.execute("delete", {
          selection: i.createSelection(a, "on")
        });else {
          var u = o.getNearestSelectionRange(i.createPositionAt(a, l), c);
          if (u) if (!u.isCollapsed) i.change(function (f) {
            f.setSelection(u), e.execute(d ? "deleteForward" : "delete");
          });else {
            var f = i.createSelection(u.start);
            if (i.modifySelection(f, {
              direction: c
            }), !f.focus.isEqual(u.start)) i.change(function (y) {
              y.setSelection(u), e.execute(d ? "deleteForward" : "delete");
            });else {
              var y = Ce(o, u.start.parent);
              i.deleteContent(i.createSelection(y, "on"), {
                doNotAutoparagraph: !0
              });
            }
          }
        }
        r.preventDefault(), n.stop();
      }, {
        context: p
      });
    }
  }, {
    key: "_enableInsertContentIntegration",
    value: function _enableInsertContentIntegration() {
      var e = this.editor,
        t = this.editor.model,
        i = t.document.selection;
      this._listenToIfEnabled(e.model, "insertContent", function (o, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          n = _ref2[0],
          r = _ref2[1];
        if (r && !r.is("documentSelection")) return;
        var l = w(i);
        if (l) return o.stop(), t.change(function (c) {
          var a = i.getSelectedElement(),
            h = t.createPositionAt(a, l),
            d = c.createSelection(h),
            g = t.insertContent(n, d);
          return c.setSelection(d), g;
        });
      }, {
        priority: "high"
      });
    }
  }, {
    key: "_enableInsertObjectIntegration",
    value: function _enableInsertObjectIntegration() {
      var e = this.editor,
        i = this.editor.model.document.selection;
      this._listenToIfEnabled(e.model, "insertObject", function (o, n) {
        var _n = _slicedToArray(n, 3),
          r = _n[1],
          _n$ = _n[2],
          l = _n$ === void 0 ? {} : _n$;
        if (r && !r.is("documentSelection")) return;
        var c = w(i);
        c && (l.findOptimalPosition = c, n[3] = l);
      }, {
        priority: "high"
      });
    }
  }, {
    key: "_enableDeleteContentIntegration",
    value: function _enableDeleteContentIntegration() {
      var e = this.editor,
        i = this.editor.model.document.selection;
      this._listenToIfEnabled(e.model, "deleteContent", function (o, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
          n = _ref4[0];
        if (n && !n.is("documentSelection")) return;
        w(i) && o.stop();
      }, {
        priority: "high"
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "WidgetTypeAround";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [ne, V];
    }
  }]);
}(E);
function Ee(s, e, t) {
  var i = s.createUIElement("div", {
    class: "ck ck-reset_all ck-widget__type-around"
  }, function (o) {
    var n = this.toDomElement(o);
    return Se(n, e), Pe(n), n;
  });
  s.insert(s.createPositionAt(t, "end"), i);
}
function Se(s, e) {
  for (var _i = 0, _M = M; _i < _M.length; _i++) {
    var t = _M[_i];
    var i = new C({
      tag: "div",
      attributes: {
        class: ["ck", "ck-widget__type-around__button", "ck-widget__type-around__button_".concat(t)],
        title: e[t],
        "aria-hidden": "true"
      },
      children: [s.ownerDocument.importNode(ye, !0)]
    });
    s.appendChild(i.render());
  }
}
function Pe(s) {
  var e = new C({
    tag: "div",
    attributes: {
      class: ["ck", "ck-widget__type-around__fake-caret"]
    }
  });
  s.appendChild(e.render());
}
function Ce(s, e) {
  var t = e;
  var _iterator2 = _createForOfIteratorHelper(e.getAncestors({
      parentFirst: !0
    })),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var i = _step2.value;
      if (i.childCount > 1 || s.isLimit(i)) break;
      t = i;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return t;
}
function Te(s) {
  var e = s.model;
  return function (t, i) {
    var o = i.keyCode == P.arrowup,
      n = i.keyCode == P.arrowdown,
      r = i.shiftKey,
      l = e.document.selection;
    if (!o && !n) return;
    var c = n;
    if (r && Re(l, c)) return;
    var a = ke(s, l, c);
    if (a) {
      if (a.isCollapsed) {
        if (l.isCollapsed) return;
        if (r) return;
      }
      (a.isCollapsed || Ae(s, a, c)) && (e.change(function (h) {
        var d = c ? a.end : a.start;
        if (r) {
          var g = e.createSelection(l.anchor);
          g.setFocus(d), h.setSelection(g);
        } else h.setSelection(d);
      }), t.stop(), i.preventDefault(), i.stopPropagation());
    }
  };
}
function ke(s, e, t) {
  var i = s.model;
  if (t) {
    var o = e.isCollapsed ? e.focus : e.getLastPosition(),
      n = R(i, o, "forward");
    if (!n) return null;
    var r = i.createRange(o, n),
      l = W(i.schema, r, "backward");
    return l ? i.createRange(o, l) : null;
  } else {
    var _o = e.isCollapsed ? e.focus : e.getFirstPosition(),
      _n2 = R(i, _o, "backward");
    if (!_n2) return null;
    var _r = i.createRange(_n2, _o),
      _l = W(i.schema, _r, "forward");
    return _l ? i.createRange(_l, _o) : null;
  }
}
function R(s, e, t) {
  var i = s.schema,
    o = s.createRangeIn(e.root),
    n = t == "forward" ? "elementStart" : "elementEnd";
  var _iterator3 = _createForOfIteratorHelper(o.getWalker({
      startPosition: e,
      direction: t
    })),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ref5 = _step3.value;
      var r = _ref5.previousPosition;
      var l = _ref5.item;
      var c = _ref5.type;
      if (i.isLimit(l) && !i.isInline(l)) return r;
      if (c == n && i.isBlock(l)) return null;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return null;
}
function W(s, e, t) {
  var i = t == "backward" ? e.end : e.start;
  if (s.checkChild(i, "$text")) return i;
  var _iterator4 = _createForOfIteratorHelper(e.getWalker({
      direction: t
    })),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _ref6 = _step4.value;
      var o = _ref6.nextPosition;
      if (s.checkChild(o, "$text")) return o;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return null;
}
function Ae(s, e, t) {
  var i = s.model,
    o = s.view.domConverter;
  if (t) {
    var a = i.createSelection(e.start);
    i.modifySelection(a), !a.focus.isAtEnd && !e.start.isEqual(a.focus) && (e = i.createRange(a.focus, e.end));
  }
  var n = s.mapper.toViewRange(e),
    r = o.viewRangeToDom(n),
    l = b.getDomRangeRects(r);
  var c;
  var _iterator5 = _createForOfIteratorHelper(l),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _a = _step5.value;
      if (c === void 0) {
        c = Math.round(_a.bottom);
        continue;
      }
      if (Math.round(_a.top) >= c) return !1;
      c = Math.max(c, Math.round(_a.bottom));
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return !0;
}
function Re(s, e) {
  return !s.isCollapsed && s.isBackward == e;
}
var it = /*#__PURE__*/function (_E2) {
  function it() {
    var _this9;
    _classCallCheck(this, it);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this9 = _callSuper(this, it, [].concat(args));
    _defineProperty(_this9, "_previouslySelected", new Set());
    return _this9;
  }
  _inherits(it, _E2);
  return _createClass(it, [{
    key: "init",
    value: function init() {
      var _this0 = this;
      var e = this.editor,
        t = e.editing.view,
        i = t.document,
        o = e.t;
      this.editor.editing.downcastDispatcher.on("selection", function (n, r, l) {
        var c = l.writer,
          a = r.selection;
        if (a.isCollapsed) return;
        var h = a.getSelectedElement();
        if (!h) return;
        var d = e.editing.mapper.toViewElement(h);
        p(d) && l.consumable.consume(a, "selection") && c.setSelection(c.createRangeOn(d), {
          fake: !0,
          label: ue(d)
        });
      }), this.editor.editing.downcastDispatcher.on("selection", function (n, r, l) {
        _this0._clearPreviouslySelectedWidgets(l.writer);
        var c = l.writer,
          a = c.document.selection;
        var h = null;
        var _iterator6 = _createForOfIteratorHelper(a.getRanges()),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var d = _step6.value;
            var _iterator7 = _createForOfIteratorHelper(d),
              _step7;
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var g = _step7.value;
                var u = g.item;
                p(u) && !xe(u, h) && (c.addClass(k, u), _this0._previouslySelected.add(u), h = u);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }, {
        priority: "low"
      }), t.addObserver(H), this.listenTo(i, "mousedown", function () {
        return _this0._onMousedown.apply(_this0, arguments);
      }), this.listenTo(i, "arrowKey", function () {
        _this0._handleSelectionChangeOnArrowKeyPress.apply(_this0, arguments);
      }, {
        context: [p, "$text"]
      }), this.listenTo(i, "arrowKey", function () {
        _this0._preventDefaultOnArrowKeyPress.apply(_this0, arguments);
      }, {
        context: "$root"
      }), this.listenTo(i, "arrowKey", Te(this.editor.editing), {
        context: "$text"
      }), this.listenTo(i, "delete", function (n, r) {
        _this0._handleDelete(r.direction == "forward") && (r.preventDefault(), n.stop());
      }, {
        context: "$root"
      }), this.listenTo(i, "tab", function (n, r) {
        n.eventPhase == "atTarget" && (r.shiftKey || _this0._selectFirstNestedEditable() && (r.preventDefault(), n.stop()));
      }, {
        context: p,
        priority: "low"
      }), this.listenTo(i, "tab", function (n, r) {
        r.shiftKey && _this0._selectAncestorWidget() && (r.preventDefault(), n.stop());
      }, {
        priority: "low"
      }), this.listenTo(i, "keydown", function (n, r) {
        r.keystroke == P.esc && _this0._selectAncestorWidget() && (r.preventDefault(), n.stop());
      }, {
        priority: "low"
      }), e.accessibility.addKeystrokeInfoGroup({
        id: "widget",
        label: o("Keystrokes that can be used when a widget is selected (for example: image, table, etc.)"),
        keystrokes: [{
          label: o("Move focus from an editable area back to the parent widget"),
          keystroke: "Esc"
        }, {
          label: o("Insert a new paragraph directly after a widget"),
          keystroke: "Enter"
        }, {
          label: o("Insert a new paragraph directly before a widget"),
          keystroke: "Shift+Enter"
        }, {
          label: o("Move the caret to allow typing directly before a widget"),
          keystroke: [["arrowup"], ["arrowleft"]]
        }, {
          label: o("Move the caret to allow typing directly after a widget"),
          keystroke: [["arrowdown"], ["arrowright"]]
        }]
      });
    }
  }, {
    key: "_onMousedown",
    value: function _onMousedown(e, t) {
      var i = this.editor,
        o = i.editing.view,
        n = o.document;
      var r = t.target;
      if (!r) return;
      if (t.domEvent.detail >= 3) {
        this._selectBlockContent(r) && t.preventDefault();
        return;
      }
      if (!p(r)) {
        var c = We(r);
        if (!c) return;
        if (p(c)) r = c;else {
          var a = ze(o, t);
          if (a && p(a)) r = a;else return;
        }
      }
      D.isAndroid && t.preventDefault(), n.isFocused || o.focus();
      var l = i.editing.mapper.toModelElement(r);
      this._setSelectionOverElement(l);
    }
  }, {
    key: "_selectBlockContent",
    value: function _selectBlockContent(e) {
      var t = this.editor,
        i = t.model,
        o = t.editing.mapper,
        n = i.schema,
        r = o.findMappedViewAncestor(this.editor.editing.view.createPositionAt(e, 0)),
        l = He(o.toModelElement(r), i.schema);
      return l ? (i.change(function (c) {
        var a = n.isLimit(l) ? null : Ve(c.createPositionAfter(l), n),
          h = c.createPositionAt(l, 0),
          d = a ? c.createPositionAt(a, 0) : c.createPositionAt(l, "end");
        c.setSelection(c.createRange(h, d));
      }), !0) : !1;
    }
  }, {
    key: "_handleSelectionChangeOnArrowKeyPress",
    value: function _handleSelectionChangeOnArrowKeyPress(e, t) {
      var i = t.keyCode,
        o = this.editor.model,
        n = o.schema,
        r = o.document.selection,
        l = r.getSelectedElement(),
        c = j(i, this.editor.locale.contentLanguageDirection),
        a = c == "down" || c == "right",
        h = c == "up" || c == "down";
      if (l && n.isObject(l)) {
        var g = a ? r.getLastPosition() : r.getFirstPosition(),
          u = n.getNearestSelectionRange(g, a ? "forward" : "backward");
        u && (o.change(function (f) {
          f.setSelection(u);
        }), t.preventDefault(), e.stop());
        return;
      }
      if (!r.isCollapsed && !t.shiftKey) {
        var _g = r.getFirstPosition(),
          _u = r.getLastPosition(),
          f = _g.nodeAfter,
          y = _u.nodeBefore;
        (f && n.isObject(f) || y && n.isObject(y)) && (o.change(function (B) {
          B.setSelection(a ? _u : _g);
        }), t.preventDefault(), e.stop());
        return;
      }
      if (!r.isCollapsed) return;
      var d = this._getObjectElementNextToSelection(a);
      if (d && n.isObject(d)) {
        if (n.isInline(d) && h) return;
        this._setSelectionOverElement(d), t.preventDefault(), e.stop();
      }
    }
  }, {
    key: "_preventDefaultOnArrowKeyPress",
    value: function _preventDefaultOnArrowKeyPress(e, t) {
      var i = this.editor.model,
        o = i.schema,
        n = i.document.selection.getSelectedElement();
      n && o.isObject(n) && (t.preventDefault(), e.stop());
    }
  }, {
    key: "_handleDelete",
    value: function _handleDelete(e) {
      var _this1 = this;
      var i = this.editor.model.document.selection;
      if (!this.editor.model.canEditAt(i) || !i.isCollapsed) return;
      var o = this._getObjectElementNextToSelection(e);
      if (o) return this.editor.model.change(function (n) {
        var r = i.anchor.parent;
        for (; r.isEmpty;) {
          var l = r;
          r = l.parent, n.remove(l);
        }
        _this1._setSelectionOverElement(o);
      }), !0;
    }
  }, {
    key: "_setSelectionOverElement",
    value: function _setSelectionOverElement(e) {
      this.editor.model.change(function (t) {
        t.setSelection(t.createRangeOn(e));
      });
    }
  }, {
    key: "_getObjectElementNextToSelection",
    value: function _getObjectElementNextToSelection(e) {
      var t = this.editor.model,
        i = t.schema,
        o = t.document.selection,
        n = t.createSelection(o);
      if (t.modifySelection(n, {
        direction: e ? "forward" : "backward"
      }), n.isEqual(o)) return null;
      var r = e ? n.focus.nodeBefore : n.focus.nodeAfter;
      return r && i.isObject(r) ? r : null;
    }
  }, {
    key: "_clearPreviouslySelectedWidgets",
    value: function _clearPreviouslySelectedWidgets(e) {
      var _iterator8 = _createForOfIteratorHelper(this._previouslySelected),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var t = _step8.value;
          e.removeClass(k, t);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      this._previouslySelected.clear();
    }
  }, {
    key: "_selectFirstNestedEditable",
    value: function _selectFirstNestedEditable() {
      var e = this.editor,
        i = this.editor.editing.view.document;
      var _iterator9 = _createForOfIteratorHelper(i.selection.getFirstRange().getItems()),
        _step9;
      try {
        var _loop = function _loop() {
            var o = _step9.value;
            if (o.is("editableElement")) {
              var n = e.editing.mapper.toModelElement(o); /* istanbul ignore next -- @preserve */
              if (!n) return 0; // continue
              var r = e.model.createPositionAt(n, 0),
                l = e.model.schema.getNearestSelectionRange(r, "forward");
              return {
                v: (e.model.change(function (c) {
                  c.setSelection(l);
                }), !0)
              };
            }
          },
          _ret;
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          _ret = _loop();
          if (_ret === 0) continue;
          if (_ret) return _ret.v;
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return !1;
    }
  }, {
    key: "_selectAncestorWidget",
    value: function _selectAncestorWidget() {
      var e = this.editor,
        t = e.editing.mapper,
        o = e.editing.view.document.selection.getFirstPosition().parent,
        r = (o.is("$text") ? o.parent : o).findAncestor(p);
      if (!r) return !1;
      var l = t.toModelElement(r); /* istanbul ignore next -- @preserve */
      return l ? (e.model.change(function (c) {
        c.setSelection(l, "on");
      }), !0) : !1;
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "Widget";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [ve, V];
    }
  }]);
}(E);
function We(s) {
  var e = s;
  for (; e;) {
    if (e.is("editableElement") || p(e)) return e;
    e = e.parent;
  }
  return null;
}
function ze(s, e) {
  var t = q(e.domEvent);
  var i = null;
  if (t ? i = s.domConverter.domRangeToView(t) : i = s.createRange(s.createPositionAt(e.target, 0)), !i) return null;
  var o = i.start;
  if (!o.parent) return null;
  var n = o.parent;
  return o.parent.is("editableElement") && (o.isAtEnd && o.nodeBefore ? n = o.nodeBefore : o.isAtStart && o.nodeAfter && (n = o.nodeAfter)), n.is("$text") ? n.parent : n;
}
function xe(s, e) {
  return e ? Array.from(s.getAncestors()).includes(e) : !1;
}
function He(s, e) {
  var _iterator0 = _createForOfIteratorHelper(s.getAncestors({
      includeSelf: !0,
      parentFirst: !0
    })),
    _step0;
  try {
    for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
      var t = _step0.value;
      if (e.checkChild(t, "$text")) return t;
      if (e.isLimit(t) && !e.isObject(t)) break;
    }
  } catch (err) {
    _iterator0.e(err);
  } finally {
    _iterator0.f();
  }
  return null;
}
function Ve(s, e) {
  var t = new K({
    startPosition: s
  });
  var _iterator1 = _createForOfIteratorHelper(t),
    _step1;
  try {
    for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
      var _ref7 = _step1.value;
      var i = _ref7.item;
      if (e.isLimit(i) || !i.is("element")) return null;
      if (e.checkChild(i, "$text")) return i;
    }
  } catch (err) {
    _iterator1.e(err);
  } finally {
    _iterator1.f();
  }
  return null;
}
var ot = /*#__PURE__*/function (_E3) {
  function ot() {
    var _this10;
    _classCallCheck(this, ot);
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    _this10 = _callSuper(this, ot, [].concat(args));
    _defineProperty(_this10, "_toolbarDefinitions", new Map());
    _defineProperty(_this10, "_balloon", void 0);
    return _this10;
  }
  _inherits(ot, _E3);
  return _createClass(ot, [{
    key: "init",
    value: function init() {
      var _this11 = this;
      var e = this.editor;
      if (e.plugins.has("BalloonToolbar")) {
        var t = e.plugins.get("BalloonToolbar");
        this.listenTo(t, "show", function (i) {
          De(e.editing.view.document.selection) && i.stop();
        }, {
          priority: "high"
        });
      }
      this._balloon = this.editor.plugins.get("ContextualBalloon"), this.on("change:isEnabled", function () {
        _this11._updateToolbarsVisibility();
      }), this.listenTo(e.ui, "update", function () {
        _this11._updateToolbarsVisibility();
      }), this.listenTo(e.ui.focusTracker, "change:isFocused", function () {
        _this11._updateToolbarsVisibility();
      }, {
        priority: "low"
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(ot, "destroy", this, 3)([]);
      var _iterator10 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var e = _step10.value;
          e.view.destroy();
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }, {
    key: "register",
    value: function register(e, _ref8) {
      var _this12 = this;
      var t = _ref8.ariaLabel,
        i = _ref8.items,
        o = _ref8.getRelatedElement,
        _ref8$balloonClassNam = _ref8.balloonClassName,
        n = _ref8$balloonClassNam === void 0 ? "ck-toolbar-container" : _ref8$balloonClassNam,
        r = _ref8.positions;
      if (!i.length) {
        $("widget-toolbar-no-items", {
          toolbarId: e
        });
        return;
      }
      var l = this.editor,
        c = l.t,
        a = new ee(l.locale);
      if (a.ariaLabel = t || c("Widget toolbar"), this._toolbarDefinitions.has(e)) throw new I("widget-toolbar-duplicated", this, {
        toolbarId: e
      });
      var h = {
        view: a,
        getRelatedElement: o,
        balloonClassName: n,
        itemsConfig: i,
        positions: r,
        initialized: !1
      };
      l.ui.addToolbar(a, {
        isContextual: !0,
        beforeFocus: function beforeFocus() {
          var d = o(l.editing.view.document.selection);
          d && _this12._showToolbar(h, d);
        },
        afterBlur: function afterBlur() {
          _this12._hideToolbar(h);
        }
      }), this._toolbarDefinitions.set(e, h);
    }
  }, {
    key: "_updateToolbarsVisibility",
    value: function _updateToolbarsVisibility() {
      var e = 0,
        t = null,
        i = null;
      var _iterator11 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var o = _step11.value;
          var n = o.getRelatedElement(this.editor.editing.view.document.selection);
          if (!this.isEnabled || !n) this._isToolbarInBalloon(o) && this._hideToolbar(o);else if (!this.editor.ui.focusTracker.isFocused) this._isToolbarVisible(o) && this._hideToolbar(o);else {
            var r = n.getAncestors().length;
            r > e && (e = r, t = n, i = o);
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      i && this._showToolbar(i, t);
    }
  }, {
    key: "_hideToolbar",
    value: function _hideToolbar(e) {
      this._balloon.remove(e.view), this.stopListening(this._balloon, "change:visibleView");
    }
  }, {
    key: "_showToolbar",
    value: function _showToolbar(e, t) {
      var _this13 = this;
      this._isToolbarVisible(e) ? z(this.editor, t, e.positions) : this._isToolbarInBalloon(e) || (e.initialized || (e.initialized = !0, e.view.fillFromConfig(e.itemsConfig, this.editor.ui.componentFactory)), this._balloon.add({
        view: e.view,
        position: L(this.editor, t, e.positions),
        balloonClassName: e.balloonClassName
      }), this.listenTo(this._balloon, "change:visibleView", function () {
        var _iterator12 = _createForOfIteratorHelper(_this13._toolbarDefinitions.values()),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var i = _step12.value;
            if (_this13._isToolbarVisible(i)) {
              var o = i.getRelatedElement(_this13.editor.editing.view.document.selection);
              z(_this13.editor, o, e.positions);
            }
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }));
    }
  }, {
    key: "_isToolbarVisible",
    value: function _isToolbarVisible(e) {
      return this._balloon.visibleView === e.view;
    }
  }, {
    key: "_isToolbarInBalloon",
    value: function _isToolbarInBalloon(e) {
      return this._balloon.hasView(e.view);
    }
  }], [{
    key: "requires",
    get: function get() {
      return [Z];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return "WidgetToolbarRepository";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(E);
function z(s, e, t) {
  var i = s.plugins.get("ContextualBalloon"),
    o = L(s, e, t);
  i.updatePosition(o);
}
function L(s, e, t) {
  var i = s.editing.view,
    o = te.defaultPositions;
  return {
    target: i.domConverter.mapViewToDom(e),
    positions: t || [o.northArrowSouth, o.northArrowSouthWest, o.northArrowSouthEast, o.southArrowNorth, o.southArrowNorthWest, o.southArrowNorthEast, o.viewportStickyNorth]
  };
}
function De(s) {
  var e = s.getSelectedElement();
  return !!(e && p(e));
}
var Ie = /*#__PURE__*/function (_F) {
  function Ie(e) {
    var _this14;
    _classCallCheck(this, Ie);
    _this14 = _callSuper(this, Ie), _defineProperty(_assertThisInitialized(_this14), "_referenceCoordinates", void 0), _defineProperty(_assertThisInitialized(_this14), "_options", void 0), _defineProperty(_assertThisInitialized(_this14), "_originalWidth", void 0), _defineProperty(_assertThisInitialized(_this14), "_originalHeight", void 0), _defineProperty(_assertThisInitialized(_this14), "_originalWidthPercents", void 0), _defineProperty(_assertThisInitialized(_this14), "_aspectRatio", void 0), _this14.set("activeHandlePosition", null), _this14.set("proposedWidthPercents", null), _this14.set("proposedWidth", null), _this14.set("proposedHeight", null), _this14.set("proposedHandleHostWidth", null), _this14.set("proposedHandleHostHeight", null), _this14._options = e, _this14._referenceCoordinates = null;
    return _this14;
  }
  _inherits(Ie, _F);
  return _createClass(Ie, [{
    key: "originalWidth",
    get: function get() {
      return this._originalWidth;
    }
  }, {
    key: "originalHeight",
    get: function get() {
      return this._originalHeight;
    }
  }, {
    key: "originalWidthPercents",
    get: function get() {
      return this._originalWidthPercents;
    }
  }, {
    key: "aspectRatio",
    get: function get() {
      return this._aspectRatio;
    }
  }, {
    key: "begin",
    value: function begin(e, t, i) {
      var o = new b(t);
      this.activeHandlePosition = Ne(e), this._referenceCoordinates = Oe(t, Me(this.activeHandlePosition)), this._originalWidth = o.width, this._originalHeight = o.height, this._aspectRatio = o.width / o.height;
      var n = i.style.width;
      n && n.match(/^\d+(\.\d*)?%$/) ? this._originalWidthPercents = parseFloat(n) : this._originalWidthPercents = me(i, o);
    }
  }, {
    key: "update",
    value: function update(e) {
      this.proposedWidth = e.width, this.proposedHeight = e.height, this.proposedWidthPercents = e.widthPercents, this.proposedHandleHostWidth = e.handleHostWidth, this.proposedHandleHostHeight = e.handleHostHeight;
    }
  }]);
}(F());
function Oe(s, e) {
  var t = new b(s),
    i = e.split("-"),
    o = {
      x: i[1] == "right" ? t.right : t.left,
      y: i[0] == "bottom" ? t.bottom : t.top
    };
  return o.x += s.ownerDocument.defaultView.scrollX, o.y += s.ownerDocument.defaultView.scrollY, o;
}
function Fe(s) {
  return "ck-widget__resizer__handle-".concat(s);
}
function Ne(s) {
  var e = ["top-left", "top-right", "bottom-right", "bottom-left"];
  for (var _i2 = 0, _e2 = e; _i2 < _e2.length; _i2++) {
    var t = _e2[_i2];
    if (s.classList.contains(Fe(t))) return t;
  }
}
function Me(s) {
  var e = s.split("-"),
    t = {
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    };
  return "".concat(t[e[0]], "-").concat(t[e[1]]);
}
var Le = /*#__PURE__*/function (_oe) {
  function Le() {
    var _this15;
    _classCallCheck(this, Le);
    _this15 = _callSuper(this, Le);
    var e = _this15.bindTemplate;
    _this15.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-size-view", e.to("_viewPosition", function (t) {
          return t ? "ck-orientation-".concat(t) : "";
        })],
        style: {
          display: e.if("_isVisible", "none", function (t) {
            return !t;
          })
        }
      },
      children: [{
        text: e.to("_label")
      }]
    });
    return _this15;
  }
  _inherits(Le, _oe);
  return _createClass(Le, [{
    key: "_bindToState",
    value: function _bindToState(e, t) {
      this.bind("_isVisible").to(t, "proposedWidth", t, "proposedHeight", function (i, o) {
        return i !== null && o !== null;
      }), this.bind("_label").to(t, "proposedHandleHostWidth", t, "proposedHandleHostHeight", t, "proposedWidthPercents", function (i, o, n) {
        return e.unit === "px" ? "".concat(i, "\xD7").concat(o) : "".concat(n, "%");
      }), this.bind("_viewPosition").to(t, "activeHandlePosition", t, "proposedHandleHostWidth", t, "proposedHandleHostHeight", function (i, o, n) {
        return o < 50 || n < 50 ? "above-center" : i;
      });
    }
  }, {
    key: "_dismiss",
    value: function _dismiss() {
      this.unbind(), this._isVisible = !1;
    }
  }]);
}(oe);
var x = /*#__PURE__*/function (_F2) {
  function x(e) {
    var _this16;
    _classCallCheck(this, x);
    _this16 = _callSuper(this, x), _defineProperty(_assertThisInitialized(_this16), "_state", void 0), _defineProperty(_assertThisInitialized(_this16), "_sizeView", void 0), _defineProperty(_assertThisInitialized(_this16), "_options", void 0), _defineProperty(_assertThisInitialized(_this16), "_viewResizerWrapper", null), _defineProperty(_assertThisInitialized(_this16), "_initialViewWidth", void 0), _this16._options = e, _this16.set("isEnabled", !0), _this16.set("isSelected", !1), _this16.bind("isVisible").to(_assertThisInitialized(_this16), "isEnabled", _this16, "isSelected", function (t, i) {
      return t && i;
    }), _this16.decorate("begin"), _this16.decorate("cancel"), _this16.decorate("commit"), _this16.decorate("updateSize"), _this16.on("commit", function (t) {
      !_this16.state.proposedWidth && !_this16.state.proposedWidthPercents && (_this16._cleanup(), t.stop());
    }, {
      priority: "high"
    });
    return _this16;
  }
  _inherits(x, _F2);
  return _createClass(x, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "show",
    value: function show() {
      var _this17 = this;
      this._options.editor.editing.view.change(function (t) {
        t.removeClass("ck-hidden", _this17._viewResizerWrapper);
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this18 = this;
      this._options.editor.editing.view.change(function (t) {
        t.addClass("ck-hidden", _this18._viewResizerWrapper);
      });
    }
  }, {
    key: "attach",
    value: function attach() {
      var _this19 = this;
      var e = this,
        t = this._options.viewElement;
      this._options.editor.editing.view.change(function (o) {
        var n = o.createUIElement("div", {
          class: "ck ck-reset_all ck-widget__resizer"
        }, function (r) {
          var l = this.toDomElement(r);
          return e._appendHandles(l), e._appendSizeUI(l), l;
        });
        o.insert(o.createPositionAt(t, "end"), n), o.addClass("ck-widget_with-resizer", t), _this19._viewResizerWrapper = n, _this19.isVisible || _this19.hide();
      }), this.on("change:isVisible", function () {
        _this19.isVisible ? (_this19.show(), _this19.redraw()) : _this19.hide();
      });
    }
  }, {
    key: "begin",
    value: function begin(e) {
      this._state = new Ie(this._options), this._sizeView._bindToState(this._options, this.state), this._initialViewWidth = this._options.viewElement.getStyle("width"), this.state.begin(e, this._getHandleHost(), this._getResizeHost());
    }
  }, {
    key: "updateSize",
    value: function updateSize(e) {
      var _this20 = this;
      var t = this._proposeNewSize(e);
      this._options.editor.editing.view.change(function (a) {
        var h = _this20._options.unit || "%",
          d = (h === "%" ? t.widthPercents : t.width) + h;
        a.setStyle("width", d, _this20._options.viewElement);
      });
      var o = this._getHandleHost(),
        n = new b(o),
        r = Math.round(n.width),
        l = Math.round(n.height),
        c = new b(o);
      t.width = Math.round(c.width), t.height = Math.round(c.height), this.redraw(n), this.state.update(_objectSpread(_objectSpread({}, t), {}, {
        handleHostWidth: r,
        handleHostHeight: l
      }));
    }
  }, {
    key: "commit",
    value: function commit() {
      var _this21 = this;
      var e = this._options.unit || "%",
        t = (e === "%" ? this.state.proposedWidthPercents : this.state.proposedWidth) + e;
      this._options.editor.editing.view.change(function () {
        _this21._cleanup(), _this21._options.onCommit(t);
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this._cleanup();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.cancel();
    }
  }, {
    key: "redraw",
    value: function redraw(e) {
      var t = this._domResizerWrapper;
      if (!je(t)) return;
      var i = t.parentElement,
        o = this._getHandleHost(),
        n = this._viewResizerWrapper,
        r = [n.getStyle("width"), n.getStyle("height"), n.getStyle("left"), n.getStyle("top")];
      var l;
      if (i.isSameNode(o)) {
        var c = e || new b(o);
        l = [c.width + "px", c.height + "px", void 0, void 0];
      } else l = [o.offsetWidth + "px", o.offsetHeight + "px", o.offsetLeft + "px", o.offsetTop + "px"];
      Y(r, l) !== "same" && this._options.editor.editing.view.change(function (c) {
        c.setStyle({
          width: l[0],
          height: l[1],
          left: l[2],
          top: l[3]
        }, n);
      });
    }
  }, {
    key: "containsHandle",
    value: function containsHandle(e) {
      return this._domResizerWrapper.contains(e);
    }
  }, {
    key: "_cleanup",
    value: function _cleanup() {
      var _this22 = this;
      this._sizeView._dismiss(), this._options.editor.editing.view.change(function (t) {
        t.setStyle("width", _this22._initialViewWidth, _this22._options.viewElement);
      });
    }
  }, {
    key: "_proposeNewSize",
    value: function _proposeNewSize(e) {
      var t = this.state,
        i = Ke(e),
        o = this._options.isCentered ? this._options.isCentered(this) : !0,
        n = {
          x: t._referenceCoordinates.x - (i.x + t.originalWidth),
          y: i.y - t.originalHeight - t._referenceCoordinates.y
        };
      o && t.activeHandlePosition.endsWith("-right") && (n.x = i.x - (t._referenceCoordinates.x + t.originalWidth)), o && (n.x *= 2);
      var r = Math.abs(t.originalWidth + n.x),
        l = Math.abs(t.originalHeight + n.y);
      return (r / t.aspectRatio > l ? "width" : "height") == "width" ? l = r / t.aspectRatio : r = l * t.aspectRatio, {
        width: Math.round(r),
        height: Math.round(l),
        widthPercents: Math.min(Math.round(t.originalWidthPercents / t.originalWidth * r * 100) / 100, 100)
      };
    }
  }, {
    key: "_getResizeHost",
    value: function _getResizeHost() {
      var e = this._domResizerWrapper.parentElement;
      return this._options.getResizeHost(e);
    }
  }, {
    key: "_getHandleHost",
    value: function _getHandleHost() {
      var e = this._domResizerWrapper.parentElement;
      return this._options.getHandleHost(e);
    }
  }, {
    key: "_domResizerWrapper",
    get: function get() {
      return this._options.editor.editing.view.domConverter.mapViewToDom(this._viewResizerWrapper);
    }
  }, {
    key: "_appendHandles",
    value: function _appendHandles(e) {
      var t = ["top-left", "top-right", "bottom-right", "bottom-left"];
      for (var _i3 = 0, _t = t; _i3 < _t.length; _i3++) {
        var i = _t[_i3];
        e.appendChild(new C({
          tag: "div",
          attributes: {
            class: "ck-widget__resizer__handle ".concat(Be(i))
          }
        }).render());
      }
    }
  }, {
    key: "_appendSizeUI",
    value: function _appendSizeUI(e) {
      this._sizeView = new Le(), this._sizeView.render(), e.appendChild(this._sizeView.element);
    }
  }], [{
    key: "isResizeHandle",
    value: function isResizeHandle(e) {
      return e.classList.contains("ck-widget__resizer__handle");
    }
  }]);
}(F());
function Be(s) {
  return "ck-widget__resizer__handle-".concat(s);
}
function Ke(s) {
  return {
    x: s.pageX,
    y: s.pageY
  };
}
function je(s) {
  return s && s.ownerDocument && s.ownerDocument.contains(s);
}
var nt = /*#__PURE__*/function (_E4) {
  function nt() {
    var _this23;
    _classCallCheck(this, nt);
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    _this23 = _callSuper(this, nt, [].concat(args));
    _defineProperty(_this23, "_resizers", new Map());
    _defineProperty(_this23, "_observer", void 0);
    _defineProperty(_this23, "_redrawSelectedResizerThrottled", void 0);
    return _this23;
  }
  _inherits(nt, _E4);
  return _createClass(nt, [{
    key: "init",
    value: function init() {
      var _this24 = this;
      var e = this.editor.editing,
        t = T.window.document;
      this.set("selectedResizer", null), this.set("_activeResizer", null), e.view.addObserver(H), this._observer = new (G())(), this.listenTo(e.view.document, "mousedown", this._mouseDownListener.bind(this), {
        priority: "high"
      }), this._observer.listenTo(t, "mousemove", this._mouseMoveListener.bind(this)), this._observer.listenTo(t, "mouseup", this._mouseUpListener.bind(this)), this._redrawSelectedResizerThrottled = se(function () {
        return _this24.redrawSelectedResizer();
      }, 200), this.editor.ui.on("update", this._redrawSelectedResizerThrottled), this.editor.model.document.on("change", function () {
        var _iterator13 = _createForOfIteratorHelper(_this24._resizers),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var _ref9 = _step13.value;
            var _ref0 = _slicedToArray(_ref9, 2);
            var o = _ref0[0];
            var n = _ref0[1];
            o.isAttached() || (_this24._resizers.delete(o), n.destroy());
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }, {
        priority: "lowest"
      }), this._observer.listenTo(T.window, "resize", this._redrawSelectedResizerThrottled);
      var i = this.editor.editing.view.document.selection;
      i.on("change", function () {
        var o = i.getSelectedElement(),
          n = _this24.getResizerByViewElement(o) || null;
        n ? _this24.select(n) : _this24.deselect();
      });
    }
  }, {
    key: "redrawSelectedResizer",
    value: function redrawSelectedResizer() {
      this.selectedResizer && this.selectedResizer.isVisible && this.selectedResizer.redraw();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(nt, "destroy", this, 3)([]), this._observer.stopListening();
      var _iterator14 = _createForOfIteratorHelper(this._resizers.values()),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var e = _step14.value;
          e.destroy();
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      this._redrawSelectedResizerThrottled.cancel();
    }
  }, {
    key: "select",
    value: function select(e) {
      this.deselect(), this.selectedResizer = e, this.selectedResizer.isSelected = !0;
    }
  }, {
    key: "deselect",
    value: function deselect() {
      this.selectedResizer && (this.selectedResizer.isSelected = !1), this.selectedResizer = null;
    }
  }, {
    key: "attachTo",
    value: function attachTo(e) {
      var t = new x(e),
        i = this.editor.plugins;
      if (t.attach(), i.has("WidgetToolbarRepository")) {
        var r = i.get("WidgetToolbarRepository");
        t.on("begin", function () {
          r.forceDisabled("resize");
        }, {
          priority: "lowest"
        }), t.on("cancel", function () {
          r.clearForceDisabled("resize");
        }, {
          priority: "highest"
        }), t.on("commit", function () {
          r.clearForceDisabled("resize");
        }, {
          priority: "highest"
        });
      }
      this._resizers.set(e.viewElement, t);
      var n = this.editor.editing.view.document.selection.getSelectedElement();
      return this.getResizerByViewElement(n) == t && this.select(t), t;
    }
  }, {
    key: "getResizerByViewElement",
    value: function getResizerByViewElement(e) {
      return this._resizers.get(e);
    }
  }, {
    key: "_getResizerByHandle",
    value: function _getResizerByHandle(e) {
      var _iterator15 = _createForOfIteratorHelper(this._resizers.values()),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var t = _step15.value;
          if (t.containsHandle(e)) return t;
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
    }
  }, {
    key: "_mouseDownListener",
    value: function _mouseDownListener(e, t) {
      var i = t.domTarget;
      x.isResizeHandle(i) && (this._activeResizer = this._getResizerByHandle(i) || null, this._activeResizer && (this._activeResizer.begin(i), e.stop(), t.preventDefault()));
    }
  }, {
    key: "_mouseMoveListener",
    value: function _mouseMoveListener(e, t) {
      this._activeResizer && this._activeResizer.updateSize(t);
    }
  }, {
    key: "_mouseUpListener",
    value: function _mouseUpListener() {
      this._activeResizer && (this._activeResizer.commit(), this._activeResizer = null);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "WidgetResize";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(E);
export { ce as WIDGET_CLASS_NAME, k as WIDGET_SELECTED_CLASS_NAME, it as Widget, nt as WidgetResize, ot as WidgetToolbarRepository, ve as WidgetTypeAround, fe as calculateResizeHostAncestorWidth, me as calculateResizeHostPercentageWidth, tt as findOptimalInsertionRange, ue as getLabel, p as isWidget, N as setHighlightHandling, he as setLabel, Ze as toWidget, et as toWidgetEditable };